import { createGrid, themeQuartz } from 'ag-grid-community'
import { makeColumnDefs } from './make-column-defs.js'
import { makeRows } from './make-rows.js'
import { menuOptions } from './show-menu.js'

let gridApi

export const viewParams = {}

export function updateView () {
  const rows = makeRows(viewParams, menuOptions)
  // console.log('rows', rows)

  const columnDefs = makeColumnDefs(viewParams)
  // console.log(columnDefs)

  if (gridApi) {
    gridApi.updateGridOptions({
      rowData: rows,
      columnDefs
    })
  } else {
    const gridOptions = {
      pinnedTopRowData: [{ row: 'linkToXero' }],
      rowData: rows,
      columnDefs,
      defaultColDef: {
        filter: true,
        floatingFilter: true,
        wrapHeaderText: true,
        autoHeaderHeight: true
      },
      context: {
        menuOptions,
        associatedChartOfAccounts: viewParams.associatedChartOfAccounts,
        allChartOfAccounts: viewParams.allChartOfAccounts,
        browserAppAccount: viewParams.browserAppAccount
      },
      theme: themeQuartz,
      overlayNoRowsTemplate: 'No accounts matching',
      // autoSizeStrategy: {
      //   type: 'fitCellContents'
      // },
      onCellClicked: function (cellParams) {
        console.log('onCellClicked', cellParams)
      }
    }

    const containerId = 'viewGrid'
    const gridContainerElement = document.getElementById(containerId)
    console.log('gridContainerElement', gridContainerElement)
    gridApi = createGrid(gridContainerElement, gridOptions)
    console.log('grid created', gridApi)
  }
}
